export function Splash() {
  return (
    <div className="fixed inset-0 grid place-items-center bg-background text-foreground">
      <div className="text-lg font-display">Loading Sandbar…</div>
    </div>
  );
}
